<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div
        class="
          d-flex
          pb-6
          align-center
        "
      >
        <h2
          class="display-1"
        >Pages</h2>

        <v-spacer></v-spacer>

        <TableSearch
          label="Search pages"
          v-model="search"
          @input="doSearch"
        ></TableSearch>

        <v-switch
          v-model="showDisabled"
          label="Show disabled"
          class="pt-0 mt-0 ml-6"
          hide-details
          @change="updatePagination"
        ></v-switch>

        <NewButton
          to-name="new-page"
          class="ml-6"
        >Create new page</NewButton>
      </div>

      <v-data-table
        :headers="headers"
        :items="_pages"
        :page="page"
        :items-per-page="itemsPerPage"
        :sort-by.sync="sortBy"
        @update:sort-by="updatePagination"
        :sort-desc.sync="sortDesc"
        @update:sort-desc="updatePagination"
        multi-sort
        hide-default-footer
        :loading="loading"
        @page-count="pageCount = $event"
        @click:row="goToPage"
      >
        <template v-slot:item.title="{ item }">
          {{ item.title | striptags }}
        </template>

        <template v-slot:item.uri="{ item }">
          {{ item.uri }}
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2"
                v-on="on"
                @click.stop="goToFront(item)"
              >input</v-icon>
            </template>

            <span>View page</span>
          </v-tooltip>
        </template>

        <template v-slot:item.status="{ item }">
          <span
            class="font-weight-medium"
            :class="{
              'red--text': item.status === 'disabled',
              'green--text': item.status === 'enabled',
            }"
          >{{ $translate.instant(`PAGE_${item.status.toUpperCase()}`) }}</span>
        </template>

        <template v-slot:item.updated_at="{ item }">
          <span
            class="text-no-wrap"
            :id="`focus_${item.id}`"
          >
            {{ new Date(item.updated_at).toLocaleDateString() }}
          </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span class="text-no-wrap">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </span>
        </template>
      </v-data-table>

      <div
        class="py-6"
      >
        <TablePagination
          v-model="page"
          @input="updatePagination"
          :itemsPerPage.sync="itemsPerPage"
          @update:itemsPerPage="updatePagination"
          :pageCount="pageCount"
          :total="_pages.length"
        ></TablePagination>
      </div>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import TableSearch from '../components/TableSearch.vue'
import NewButton from '../components/NewButton.vue'
import TablePagination from '../components/TablePagination.vue'

export default {
  components: {
    ApplicationLayout,
    TableSearch,
    NewButton,
    TablePagination
  },
  data() {
    const { itemsPerPage, sortBy, sortDesc, search, showDisabled } = this.$pagination.getOptions('pages')
    return {
      search,
      pageCount: 0,
      showDisabled,
      loading: true,
      page: 1,
      sortBy,
      sortDesc,
      itemsPerPage,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Title', value: 'title' },
        { text: 'URI', value: 'uri' },
        { text: 'Status', value: 'status' },
        { text: 'Last update', value: 'updated_at' },
        { text: 'Creation date', value: 'created_at' }
      ]
    }
  },
  computed: {
    ...mapState('Pages', ['pages']),
    _pages() {
      return this.pages
        .filter((page) => {
          if (this.showDisabled) return true
          return page.status === 'enabled'
        })
    }
  },
  async created() {
    await this.$store.dispatch('Pages/getAll', { search: this.search })
    const { page } = this.$pagination.getOptions('pages')
    this.page = page
    this.$pagination.focus()
    this.updatePagination()
    this.loading = false
  },
  methods: {
    updatePagination() {
      this.$pagination.update({
        itemsPerPage: this.itemsPerPage,
        page: this.page,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search,
        showDisabled: this.showDisabled
      }, 'pages')
    },
    goToPage(page) {
      this.$router.push({
        name: 'page',
        params: { id: page.id }
      })
    },
    goToFront(page) {
      window.open(`${process.env.VUE_APP_FRONT_URL}${page.uri}.html`, '_blank')
    },
    async doSearch() {
      this.page = 1
      this.loading = true
      await this.$store.dispatch('Pages/getAll', { search: this.search })
      this.loading = false
      this.updatePagination()
    }
  }
}
</script>
